export default {
      id: "cal-usage",
      viewBox: "0 0 17 18",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#cal",
      toString: function () {
        return this.url;
      }
    }